import { useEffect } from "react";

import { TIER } from "../tier";

const APP_TITLE = `Rumi ${TIER}`;

/** The tab and history title for a page: "Rumi Golden - Case 5 - Run 34", or "Rumi Bronze - …" in QAT. */
export const pageTitle = (...parts: readonly string[]): string =>
  [APP_TITLE, ...parts].join(" - ");

/** Names the page in the browser tab and history while it is shown. */
export const usePageTitle = (...parts: readonly string[]): void => {
  const title = pageTitle(...parts);
  // The document title lives outside React.
  useEffect(() => {
    document.title = title;
  }, [title]);
};
